/**
 * Voxly — tiny environment-aware logger.
 * - In development: forwards to console.{warn,error,info,debug}.
 * - In production: silenced for `warn`/`debug`/`info`; only `error` is forwarded
 *   so genuine bugs still surface via the browser console (and any monitoring
 *   layer can wrap window.console.error).
 */
const isDev = process.env.NODE_ENV !== "production";

function fmt(tag, args) {
  return tag ? [`[${tag}]`, ...args] : args;
}

export const logger = {
  warn: (tag, ...args) => {
    if (isDev) console.warn(...fmt(tag, args));
  },
  info: (tag, ...args) => {
    if (isDev) console.info(...fmt(tag, args));
  },
  debug: (tag, ...args) => {
    if (isDev) console.debug(...fmt(tag, args));
  },
  // Errors always surface — production monitoring needs them.
  error: (tag, ...args) => {
    console.error(...fmt(tag, args));
  },
};

export default logger;
